/* @flow */
import Unsubscribe from 'entities/Unsubscribe';

const UnsubscribeActions = {
  confirm(token: string): Promise<Unsubscribe> {
    return new Unsubscribe({ token }).fetch({ data: { token } });
  },

  unsubscribe(emailSubscription: Unsubscribe) {
    return emailSubscription.unsubscribe();
  },
};

export default UnsubscribeActions;



// WEBPACK FOOTER //
// ./src/actions/UnsubscribeActions.js